import * as types from './types';

export const checkFilter = isValid => {
    return {
        type: types.CHECK_FILTER,
        isValid
    };
};

export const getNextStep = (id, text, plattform) => {
    return {
        type: types.FILTER_GET_NEXT_STEP,
        id,
        text,
        plattform
    };
};
